import * as yup from 'yup';

export const feedbackSchema = yup.object({
    full_name: yup.string().required("Full Name is required"),
    phone_number: yup.string().required("Phone Number is required"),
    email_id: yup.string().email().required("Email is required"),
    comments: yup.string().required("Comments is required").max(500, "Comments should not exceed 500 characters"),
    feedback_type: yup.string().required("Feedback Type is required"),
    user_type: yup.string().optional(),
    user_code: yup.string().optional()
})